import simpleButton from './simple-button';
import prefixTitleAndSuffixTitle from './button-with-prefix-title-and-suffix-title';
import prefixIconAndSuffixIcon from './button-with-prefix-Icon-and-suffix-Icon';

const variations = [
  simpleButton,
  prefixTitleAndSuffixTitle,
  prefixIconAndSuffixIcon,
];

export default variations;
